export const enum UpdateAppointmentStatus {
  SUCCESS = 'Success',
  ERROR = 'Error',
  SOLDOUT = 'SoldOut',
  AIRPORT_SOLDOUT = 'AirportSoldOut'
}

export default interface UpdatedAppointment {
    priceChanged: boolean,
    priceDifference: number,
    price: number|null
    status: UpdateAppointmentStatus
    sessionId: string
    appointmentId: string
    departureAirport: string|null
}
